"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asyncIsSorted = asyncIsSorted;
exports.default = void 0;

var _asyncIterable = require("../../internal/async-iterable");

var _compare = _interopRequireDefault(require("../../internal/compare"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

async function asyncIsSorted(iterable, comparator = _compare.default) {
  let a;
  let b;
  let iter;
  let done;

  try {
    iter = iterable[Symbol.asyncIterator]();
    ({
      done,
      value: b
    } = await iter.next());

    while (!done) {
      a = b;
      ({
        done,
        value: b
      } = await iter.next());

      if (!done && comparator(a, b) > 0) {
        return false;
      }
    }

    return true;
  } finally {
    if (!done && typeof iter.return === 'function') {
      iter.return();
    }
  }
}

var _default = (0, _asyncIterable.asyncIterableCurry)(asyncIsSorted, {
  reduces: true,
  minArgs: 0,
  maxArgs: 1
});

exports.default = _default;